function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.9 5C1.9 3.29 3.29 1.9 5 1.9L9 1.9L9 0L5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10L9 10L9 8.1L5 8.1C3.29 8.1 1.9 6.71 1.9 5ZM6 6L14 6L14 4L6 4L6 6ZM11 0L15 0C17.76 0 20 2.24 20 5C20 7.76 17.76 10 15 10L11 10L11 8.1L15 8.1C16.71 8.1 18.1 6.71 18.1 5C18.1 3.29 16.71 1.9 15 1.9L11 1.9L11 0Z",
  fill: "white"
});

var SvgSizeSettings = function SvgSizeSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSizeSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/size_settings.22d5b84b.svg";
export { ForwardRef as ReactComponent };